export const SANITY_TOKEN = process.env.SANITY_TOKEN;

export const SANITY_QUERY_BRAND = process.env.SANITY_QUERY_BRAND;

export const PACKAGE_AVAILABILITY_URL = process.env.PACKAGE_AVAILABILITY_URL;

export const REDIS_URL = process.env.REDIS_URL ?? '';

export const CONTENTFUL_ACCESS_TOKEN = process.env.CONTENTFUL_ACCESS_TOKEN;

export const CONTENTFUL_PREVIEW_ACCESS_TOKEN =
  process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN;

export const CONTENTFUL_ENVIRONMENT = process.env.CONTENTFUL_ENVIRONMENT;
export const CONTENTFUL_SPACE_ID = process.env.CONTENTFUL_SPACE_ID;
